import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import {
  IssueSLAsMultipleSelector,
  type TransformedIssueSLAsDto,
} from '../../../inputs';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { useDataGridContext } from '../../data-grid-context';
import { ContainerPopper } from './container-popper';

export function DataGridIssueSLAsFilter(params: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const value: TransformedIssueSLAsDto[] =
    context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0
            ? value.map((issueSLA) => issueSLA.slaDueDays).join(', ')
            : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueSLAsMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
